import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { selectQuizById } from 'features/quizzes/quizzesSlice';
import { usePolls } from 'features/polls/usePolls';
import { deleteQuizRequested } from 'features/quizzes/actions';

const DeleteQuizConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const quizId = modalData.id as string;

  const { isFeatureAvailable, canManagePolls } = usePolls();

  const quiz = useAppSelector((state) => selectQuizById(state, quizId));

  const shouldClose = !isFeatureAvailable || !canManagePolls || !quiz;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('deleteQuiz'));
    }
  }, [shouldClose, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('deleteQuiz'));
  };

  const handleOk = () => {
    dispatch(deleteQuizRequested(quizId));
    dispatch(closeModal('deleteQuiz'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      title={t('quizzes.delete_quiz.title')}
      description={t('quizzes.delete_quiz.description')}
      cancelText={t('quizzes.delete_quiz.btn_cancel_label')}
      okText={t('quizzes.delete_quiz.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default DeleteQuizConfirmation;
